module.exports = __webpack_public_path__ + "assets/img/vip-avatar.e81b6550.png";